import React, { Suspense, useEffect, useState } from 'react';
import ProgressDashboard from '@components/progress/ProgressDashboard';
import { Container } from 'geniebook-ui/dist';
import { useSubjectMenuList } from '@hooks/student.hook';
import { Link, useNavigate, useParams } from 'react-router-dom';
import {
  subjectIdFromName,
  subjectRouteFromId,
} from '@utils/helpers/SubjectParser';
import { MENU_PAGE_PROGRESS } from '@utils/constants/menu.constants';
import FloatingButton from '@components/genieask/FloatingButton';
import { BackgroundContainer } from '@assets/styles/background.style';
import {
  haveSkillLevelInfo,
  resetToDefaultNavbarState,
} from '@atom/navbarAtom';
import { Provider, useStore, useAtomValue } from 'jotai';
import progressStore from '@components/progress/ProgressStore';
import { useFeatureIsOn } from '@growthbook/growthbook-react';
import ProgressDashboardV2 from '@components/progress/ProgressDashboardV2';
import { userDetailQueryAtom } from '@atom/globalQueryAtom';
import { useIsJCUser } from '@hooks/user.hook';

const ProgressDashboardPage = () => {
  // redirection if the student can't open the progress page of this subject
  const rawSubjectList = useSubjectMenuList();
  const navigate = useNavigate();
  const { subjectId } = useParams();
  const store = useStore();
  const newProgressIsOn = useFeatureIsOn('student_new_progress_page');
  const userDetail = useAtomValue(userDetailQueryAtom);
  const { isJC } = useIsJCUser({
    subjectId: Number(subjectIdFromName(subjectId)),
  });
  const [isTimedOption, setIsTimedOption] = useState(false);

  const toggleTimedOption = (value: boolean) => {
    setIsTimedOption(value);
  };

  useEffect(() => {
    store.set(haveSkillLevelInfo, true);

    return () => {
      resetToDefaultNavbarState();
    };
  }, [userDetail]);

  useEffect(() => {
    if (!rawSubjectList.isLoading) {
      let list = rawSubjectList.data?.data?.data;
      if (Array.isArray(list)) {
        list = list.filter(item => item.menu_list.includes(MENU_PAGE_PROGRESS));
        const filtered = list.filter(
          item =>
            parseInt(item.subject_id) == subjectIdFromName(subjectId ?? ''),
        );
        if (filtered.length == 0) {
          navigate({
            pathname:
              '/' +
              subjectRouteFromId(parseInt(list[0].subject_id)) +
              '/progress',
          });
        }
      }
    }
  }, [rawSubjectList.data]);

  return (
    <BackgroundContainer
      className={
        isTimedOption
          ? 'max-md:h-[calc(100svh-116px)] max-lg:h-[calc(100svh-136px)]'
          : 'max-md:h-[calc(100svh-92px)] max-lg:h-[calc(100svh-124px)]'
      }
    >
      <Container className={'pt-6 md:pt-8'}>
        <Suspense>
          <Provider store={progressStore}>
            {newProgressIsOn || isJC ? (
              <ProgressDashboardV2 toggleTimedOption={toggleTimedOption} />
            ) : (
              <ProgressDashboard />
            )}
          </Provider>
          {/* set to hide for now until next instruction */}
          <Container className="relative hidden">
            <Link to="/genieask" target="_blank" rel="noopener noreferrer">
              <FloatingButton bottomPosition="lg:bottom-7 max-lg:bottom-12" />
            </Link>
          </Container>
        </Suspense>
      </Container>
    </BackgroundContainer>
  );
};

export default ProgressDashboardPage;
